<template>
    <form @submit.prevent="store" class="settings-block">
        <div class="block-header">
            <h3>{{ $t('Персональные данные') }}</h3>
        </div>
        <div class="block-content">
            <div class="form-group">
                <label for="">{{ $t('Имя') }}:</label>
                <input type="text" v-model="form.name" :placeholder="$t('Введите Имя')" :class="{'form-control': true, 'is-invalid': hasError('name')}">
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('name')">{{ getError('name') }}</span>
        
            <div class="form-group">
                <label for="">{{ $t('Email') }}:</label>
                <input type="email" v-model="form.email" readonly :placeholder="$t('Введите Email')" :class="{'form-control': true, 'is-invalid': hasError('email')}">
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('email')">{{ getError('email') }}</span>

            <div class="form-group">
                <label for="">{{ $t('Номер телефона') }}:</label>
                <input type="text" :class="{'form-control': true, 'is-invalid': hasError('phone')}" v-model="form.phone" :placeholder="$t('Введите телефон')">
            </div>
            <span class="invalid-feedback d-block" v-if="hasError('phone')">{{ getError('phone') }}</span>
        
            <div class="btn-group">
                <button type="submit" class="btn btn-blue">{{ $t('Сохранить') }}</button>
            </div>
        </div>
    </form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { EventBus } from '../../../event-bus';

export default {
    name: "PersonalData",

    data: function() {
        return {
            form: {
                email: null,
                name: null,
                phone: null,
            },
            
            errors: {},
        };
    },

    mounted() {
        this.initData();
    },

    watch: {
        "form.email": function() {
            delete this.errors['email'];
        },
        "form.name": function() {
            delete this.errors['email'];
        },
        "form.phone": function() {
            delete this.errors['email'];
        },
        "user": function() {
            this.initData();
        },
    },

    computed: {
        ...mapState(['user']),
    },

    methods: {
        ...mapActions(['loadUserData']),

        initData() {
            this.form.email = this.user.email;
            this.form.name = this.user.name;
            this.form.phone = this.user.phone;
        },

        store() {
            axios.post('/settings/personal', this.form)
                .then(({data}) => {
                    EventBus.$emit('show-alert', data.message ? data.message : $t('Настройки сохранены'), 'success');

                    this.$ga.event("personalData", "changed");

                    this.loadUserData();
                }).catch(({response}) => {
                    console.log(response);
                    
                    if(response.status !== 422) {
                        return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');   
                    }

                    this.errors = response.data.data;
                });
        },

        hasError(name) {
            return this.errors[name] !== undefined;
        },
        
        getError(name) {
            if(this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }

            return "";
        },
    },
};
</script>